import env from '../config/env';
import SubscribableProduct from '../interfaces/subscribableProduct';
import { get } from '../utils/api';
import { apiPaths } from '../utils/apiPaths';

const getSubscribableProducts = async (): Promise<SubscribableProduct> => {
  const url = `${apiPaths.getSubscribableProducts}?campaignType=SHOP`;
  return get(env.ACE_API_URL || 'https://ace-api.fabfitfun.com', url).then(
    (response) => response.data,
  );
};

export { getSubscribableProducts };
